import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { api } from '@/services/api'
import type { UserTransaction } from '@/types'

export const useTransactionsStore = defineStore('transactions', () => {
  // State
  const transactions = ref<UserTransaction[]>([])
  const loading = ref(false)
  const loaded = ref(false)

  // Getters
  const getTransactionById = computed(() => {
    return (id: string) => transactions.value.find((t) => t.id === id)
  })

  const pendingTransactions = computed(() => {
    return transactions.value.filter((t) => t.status === 'PENDING')
  })

  const confirmedTransactions = computed(() => {
    return transactions.value.filter((t) => t.status === 'COMPLETED')
  })

  // Actions
  async function loadTransactions() {
    loading.value = true

    try {
      transactions.value = await api.get<UserTransaction[]>('events/user-transactions')
      loaded.value = true
    } finally {
      loading.value = false
    }
  }

  function reset() {
    transactions.value = []
    loaded.value = false
  }

  return {
    // State
    transactions,
    loading,
    loaded,
    // Getters
    getTransactionById,
    pendingTransactions,
    confirmedTransactions,
    // Actions
    loadTransactions,
    reset,
  }
})
